module.exports = __webpack_public_path__ + "img/stock7.f150831c.png";